import { render, staticRenderFns } from "./reminderTypes.vue?vue&type=template&id=0d1a30fa"
import script from "./reminderTypes.vue?vue&type=script&lang=js"
export * from "./reminderTypes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports